import { TextField, TextFieldProps, styled } from '@mui/material';
import { IconButton } from 'components/IconButton';

type PageSearchTextFieldProps = TextFieldProps & {
	expanded: boolean;
};

export const PageSearchTextField = styled(TextField, {
	shouldForwardProp: (prop) => prop !== 'expanded',
})<PageSearchTextFieldProps>(({ theme, expanded }) => ({
	background: '#FFFFFF80',
	borderRadius: '10px',
	maxWidth: '340px',
	display: 'block',

	[theme.breakpoints.down('sm')]: {
		width: expanded ? '100%' : '0%',
		position: 'absolute',
		background: '#FFF',
		maxWidth: '100%',
		visibility: expanded ? 'visible' : 'hidden',
		opacity: expanded ? 1 : 0,
		transform: expanded ? 'translateX(0%)' : 'translateY(20px)',
		transition: expanded
			? 'opacity .5s linear, transform .3s linear'
			: 'visibility 0s .5s, width 0s .5s, opacity .5s linear, transform .3s linear',
	},
}));

export const SearchIconWrap = styled(IconButton)(({ theme }) => ({
	display: 'none',

	[theme.breakpoints.down('sm')]: {
		display: 'flex',
	},
}));
